import type { ReviewFormData } from '../../model/review/interfaces';

export const hasFormData = (formState: ReviewFormData): boolean => {
  return (
    formState.rating > 0 ||
    formState.title.trim() !== '' ||
    formState.content.trim() !== '' ||
    formState.nickname.trim() !== '' ||
    formState.email.trim() !== '' ||
    formState.skinType !== '' ||
    formState.skinConcern !== '' ||
    formState.images.length > 0 ||
    formState.recommend !== ''
  );
};

export const resetFormState = (setters: {
  setRating: (v: number) => void;
  setTitle: (v: string) => void;
  setContent: (v: string) => void;
  setNickname: (v: string) => void;
  setSkinType: (v: string) => void;
  setSkinConcern: (v: string) => void;
  setImages: (v: File[]) => void;
  setRecommend: (v: string) => void;
  setIsVerified?: (v: boolean) => void;
}) => {
  setters.setRating(0);
  setters.setTitle('');
  setters.setContent('');
  setters.setNickname('');
  setters.setSkinType('');
  setters.setSkinConcern('');
  setters.setImages([]);
  setters.setRecommend('');
  if (setters.setIsVerified) {
    setters.setIsVerified(false);
  }
};

export const getInitialFormState = () => ({
  rating: 0,
  title: '',
  content: '',
  nickname: '',
  email: '',
  skinType: '',
  skinConcern: '',
  images: [],
  recommend: '',
});

export const getInitialMobileFormState = () => ({
  ...getInitialFormState(),
  isVerified: false,
});
